export default {
  title: "Centropa",
  subtitle: "Project",
  paragraph: "Coming soon ...",

  custom404Title: "This site could not be found unfortunately!",
  custom404Button: "Go back",
};
